import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import {
  WorkspaceDocumentsResponse,
  CollectionLinkUnlinkRequest,
  UploadFilesRequest,
  UploadLinksResponse,
  UploadLink,
  DeleteFilesRequest
} from '../models/documents';
import { WorkspaceDocsCollectionsService } from '../services/document.service';

const mockWorkspaceDocuments: WorkspaceDocumentsResponse = {
  workspace_id: 'mock-wksp-123',
  files: [
    {
      file_id: 'd-101',
      file_name: 'report-Q3.pdf',
      uploaded_by: 'user-id-1',
      uploaded_at: '2025-10-01T10:00:00Z',
      status: 'WAITING_FOR_UPLOAD'
    },
    {
      file_id: 'd-102',
      file_name: 'budget-sheet.xlsx',
      uploaded_by: 'user-id-2',
      uploaded_at: '2025-10-02T11:30:00Z',
      status: 'WAITING_FOR_UPLOAD'
    },
    {
      file_id: 'd-103',
      file_name: 'presentation-draft.pptx',
      uploaded_by: 'user-id-1',
      uploaded_at: '2025-10-03T15:45:00Z',
      status: 'WAITING_FOR_UPLOAD'
    }
  ],
  collections: [
    {
      id: 'col-finance',
      name: 'Finance Team Docs',
      files: [
        {
          file_id: 'c-f-201',
          name: '2024 Tax Filing.pdf',
          metadata: { category: 'Tax', amount: 1200000, status: 'complete' }
        },
        {
          file_id: 'c-f-202',
          name: 'Audit Report 2023.docx',
          metadata: { category: 'Audit', approved: true }
        }
      ]
    },
    {
      id: 'col-marketing',
      name: 'Marketing Assets',
      files: [
        {
          file_id: 'c-m-301',
          name: 'Brand Guide v1.0.docx',
          metadata: { status: 'Final', owner: 'Jane Doe' }
        }
      ]
    }
  ]
};

@Injectable()
export class MockWorkspaceDocsCollectionsService
  extends WorkspaceDocsCollectionsService
  implements WorkspaceDocsCollectionsService
{
  public override linkCollections(workspaceId: string, data: CollectionLinkUnlinkRequest): Observable<void> {
    console.log(`MOCK: Linking collections ${data.collection_ids} to workspace ${workspaceId}`);
    return of(undefined).pipe(delay(2000));
  }

  public override unlinkCollections(workspaceId: string, data: CollectionLinkUnlinkRequest): Observable<void> {
    console.log(`MOCK: Unlinking collections ${data.collection_ids} from workspace ${workspaceId}`);
    return of(undefined).pipe(delay(2000));
  }

  public override getUploadUrls(workspaceId: string, data: UploadFilesRequest): Observable<UploadLinksResponse> {
    const mockLinks: UploadLink[] = data.files.map(fileName => ({
      file_name: fileName,
      url: `https://mock-s3-bucket.com/${workspaceId}/${fileName}?Signature=MOCK_TOKEN`
    }));

    return of({
      messages: `${mockLinks.length} upload links generated successfully.`,
      links: mockLinks
    }).pipe(delay(2000));
  }

  public override deleteWorkspaceFiles(workspaceId: string, data: DeleteFilesRequest): Observable<void> {
    console.log(`MOCK: Deleting files ${data.files} from workspace ${workspaceId}`);
    return of(undefined).pipe(delay(2000));
  }

  public override getWorkspaceDocuments(workspaceId: string): Observable<WorkspaceDocumentsResponse> {
    const mockResponse: WorkspaceDocumentsResponse = {
      ...mockWorkspaceDocuments,
      workspace_id: workspaceId,
      files: [...mockWorkspaceDocuments.files]
    };

    return of(mockResponse).pipe(delay(2000));
  }
}
